import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Select,
  Table,
  Typography,
} from "antd";
import React, { useState } from "react";
import MyCustomSelect, {
  formatOptionLabel,
} from "../../common/elements/myCustomSelect";
import { usePickList } from "../../services/queries";
import TextArea from "antd/es/input/TextArea";
import { openNotification } from "../../common/elements/myNotification";
import {
  deleteFromFavList,
  postGroupList,
  postHnProvGrpRounds,
} from "../../api/HnProGrpApi";
import { WarningOutlined } from "@ant-design/icons";
import DetailedCSV from "../../common/elements/DetailedCSV";
import dayjs from "dayjs";

const HnProGrpRoundsTable = ({
  mainData,
  radioData,
  archivedData,
  onUpdateData,
  FavouritesList,
  selectedRadioValue,
}) => {
  const intialReqState = {
    key: "",
    guid: "",
    mbi: "",
    codeStatus: "",
    clinicalNotes: "",
    action: "",
    diagnosis: "",
    status: "",
    createdBy: sessionStorage.getItem("userName"),
    modifiedBy: sessionStorage.getItem("userName"),
  };

  const tableData = radioData ? radioData : mainData;

  const [form] = Form.useForm();

  const codeStatusOptions = usePickList(28).data;

  const [codeStat, setCodeStat] = useState("");
  const [formData, setFormData] = useState(intialReqState);

  const [freezeEdit, setFreezeEdit] = useState(false);

  const [editingKey, setEditingKey] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedMBIs, setSelectedMBIs] = useState([]);

  const [saveListModalOpen, setSaveListModalOpen] = useState(false);
  const [isArchivedModalOpen, setIsArchivedModalOpen] = useState(false);

  const openArchiveTable = () => {
    setIsArchivedModalOpen(true);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedMBIs(newSelectedRowKeys); // Since we are using mbi as key
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const [selectedList, setSelectedList] = useState(null);

  const onListChange = (e) => {
    setSelectedList(e);
  };

  const onSubmit = async () => {
    const row = await form.validateFields();
    const finalData = { ...formData, ...row };
    setFormData(finalData);
    if (
      !finalData?.clinicalNotes ||
      !finalData?.action ||
      !finalData?.diagnosis
    ) {
      const missingFields = [];
      if (!finalData?.clinicalNotes) {
        missingFields.push("Clinical Notes");
      }
      if (!finalData?.action) {
        missingFields.push("Action");
      }
      if (!finalData?.diagnosis) {
        missingFields.push("Diagnosis");
      }

      const missingFieldsDivs = missingFields.map((field, index) => (
        <div key={index}>- {field}</div>
      ));

      openNotification(
        "warning",
        "Warning",
        <div>
          <p>Please fill all mandatory fields:</p>
          {missingFieldsDivs}
        </div>
      );
      return;
    } else {
      try {
        // setDisableButton(true);
        const response = await postHnProvGrpRounds(finalData);
        if (!formData?.guid) {
          if (response?.status === 200) {
            openNotification(
              "success",
              "Added",
              "Patient Record Updated Successfully!"
            );
          } else {
            openNotification("error", "Error", "Patient Record failed to Add");
          }
          onUpdateData(radioData ? "radio" : "main");
        } else {
          openNotification(
            "success",
            "Updated",
            "Patient Record Updated Successfully!"
          );
        }

        handleCancel();
      } catch (errInfo) {
        console.log("Validation Failed:", errInfo);
      }
      // finally {
      //   setDisableButton(false);
      //   setFreezeEdit(false);
      // }
    }
  };

  const handleEdit = (record) => {
    setFormData({
      ...formData,
      ...record,
      key: "",
      guid: "",
      createdBy: sessionStorage.getItem("userName"),
      modifiedBy: sessionStorage.getItem("userName"),
    });
    setEditingKey(record.key);
    form.setFieldsValue(record);

    setCodeStat("");
    setFreezeEdit(true);

    if (record?.guid) {
      let codeTemp = [];
      if (record?.codeStatus) {
        codeTemp = codeStatusOptions?.filter((item) => {
          return item.value === record?.codeStatus;
        });
        setCodeStat(codeTemp[0]);
      }
    }
  };

  const handleCancel = () => {
    setFormData(intialReqState);
    setEditingKey("");
    form.resetFields();
    setFreezeEdit(false);
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    ...restProps
  }) => {
    const [editingValue, setEditingValue] = useState(record?.[dataIndex]);

    const handleInputChange = (e) => {
      setEditingValue(e.target.value);
    };

    const handleSelectChange = (value) => {
      setEditingValue(value);
      form.setFieldsValue({ [dataIndex]: value?.value });
      setCodeStat(value);
    };

    const inputNode =
      dataIndex === "codeStatus" ? (
        <MyCustomSelect
          selectOptions={codeStatusOptions}
          selectedValue={codeStat}
          myCallBack={handleSelectChange}
          menuPortalTarget={document.body}
        />
      ) : (
        <TextArea rows={2} maxLength={1000} onChange={handleInputChange} />
      );

    return (
      <td {...restProps}>
        {editable && formData.mbi === record.mbi ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const onArchive = async (record) => {
    // Replace null values with empty strings
    const sanitizedRecord = Object.fromEntries(
      Object.entries(record).map(([key, value]) => [key, value ?? ""])
    );

    const response = await postHnProvGrpRounds({
      ...sanitizedRecord,
      archiveStatus: "Archived",
      modifiedBy: sessionStorage.getItem("userName"),
      createdBy: sessionStorage.getItem("userName"),
    });

    if (response?.status === 200) {
      openNotification(
        "success",
        "Added",
        "Patient Record Archived Successfully!"
      );
      onUpdateData(radioData ? "radio" : "main");
    } else {
      openNotification("error", "Error", "Patient Record failed to Archive");
    }
  };

  const onUnArchive = async (record) => {
    const updatedFormData = {
      ...record,
      archiveStatus: "NotArchived",
      modifiedBy: sessionStorage.getItem("userName"),
      createdBy: sessionStorage.getItem("userName"),
    };
    const response = await postHnProvGrpRounds(updatedFormData);
    if (response?.status === 200) {
      openNotification(
        "success",
        "Added",
        "Patient Record Reactivated Successfully!"
      );
      onUpdateData(radioData ? "radio" : "main");
    } else {
      openNotification("error", "Error", "Patient Record failed to Reactivate");
    }
  };

  const onPatientListSave = async () => {
    if (!selectedList) {
      openNotification("error", "Error", "Please select a list before saving.");
      return;
    }

    const createdBy = sessionStorage.getItem("userName");
    let successCount = 0;
    let errorCount = 0;

    await Promise.all(
      selectedMBIs.map(async (mbi) => {
        const body = {
          key: "",
          guid: "",
          grpGuid: selectedList,
          mbi: mbi,
          createdBy,
          modifiedBy: createdBy,
        };

        try {
          console.log("Saving Patient:", body);
          const response = await postGroupList(body);
          if (response?.status === 200) {
            successCount++;
          } else {
            errorCount++;
          }
        } catch (error) {
          console.error("Error saving patient:", mbi, error);
          errorCount++;
        }
      })
    );

    if (errorCount === 0) {
      openNotification(
        "success",
        "Success",
        `${successCount} patients saved successfully!`
      );
      setSaveListModalOpen(false);
    } else {
      openNotification(
        "error",
        "Error",
        `${errorCount} patients failed to save.`
      );
    }

    setSelectedRowKeys([]);
  };

  const handleListDelete = async (record) => {
    console.log(record);

    const body = {
      key: record?.guid,
      guid: record?.guid,
      grpGuid: selectedRadioValue,
      mbi: record?.mbi,
      createdBy: sessionStorage.getItem("userName"),
      modifiedBy: sessionStorage.getItem("userName"),
    };

    try {
      const response = await deleteFromFavList(body);
      if (response?.status === 200) {
        openNotification("success", "Success", ` Patient Deleted From List`);
      } else {
        openNotification("error", "Error", `Patient failed to Delete.`);
      }
      onUpdateData(radioData ? "radio" : "main");
    } catch (error) {
      console.error("Error saving patient:", error);
    }
  };

  const handleReset = () => {
    setSelectedRowKeys([]);
  };

  const columns = [
    {
      title: "Patient Name / Age / Gender",
      dataIndex: "patientNameWithDOB",
      key: "patientNameWithDOB",
      width: 400,
      render: (text, record) => (
        <>
          <div className="tw-font-medium">
            {formatOptionLabel({ label: record?.patientNameWithDOB })}
          </div>
          {record.gender === "Male" ? (
            <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
              {record.age} / M
            </p>
          ) : (
            <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
              {record.age} / F
            </p>
          )}
        </>
      ),
    },
    {
      title: "Code Status",
      dataIndex: "codeStatus",
      key: "codeStatus",
      width: 200,
      render: (text) => <span>{text?.replace(/_/g, "-")}</span>,
    },
    {
      title: "Clinical Notes",
      dataIndex: "clinicalNotes",
      key: "clinicalNotes",
      editable: true,
      width: 300,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      editable: true,
      width: 200,
    },
    {
      title: "Diagnosis",
      dataIndex: "diagnosis",
      key: "diagnosis",
      editable: true,
      width: 200,
    },
    {
      title: "Care Foundation",
      dataIndex: "completedstatus",
      key: "completedstatus",
      width: 200,
      render: (text, record) =>
        text === "Completed" ? (
          <div>
            <div>Completed</div>
            <div>{dayjs(record.completedstatusdate).format("YYYY-MM-DD")}</div>
          </div>
        ) : null,
    },
    {
      title: "Type of Utilizations",
      dataIndex: "utilisation",
      key: "utilisation",
      width: 500,
      render: (_, { utilisation }) => {
        return utilisation
          ?.split(",")
          .map((item, index) => <div key={index}>{item.trim()}</div>);
      },
    },
    {
      title: "Facility",
      dataIndex: "facilityName",
      key: "facilityName",
      width: 200,
    },
    {
      title: "CMS Provider",
      dataIndex: "cmsalignedprovider",
      key: "cmsalignedprovider",
      width: 175,
    },
    {
      title: "CCMD Provider",
      dataIndex: "ccmdProvider",
      key: "ccmdProvider",
      width: 175,
    },
    {
      title: "Operation",
      dataIndex: "guid",
      width: 130,
      fixed: "right",
      render: (_, record) =>
        editingKey === record.key ? (
          <div className="tw-space-x-6">
            <Typography.Link
              // disabled={disableButton}
              onClick={onSubmit}
            >
              Save
            </Typography.Link>
            <Typography.Link onClick={handleCancel}>Cancel</Typography.Link>
          </div>
        ) : (
          <div>
            <div className="tw-space-x-4">
              <Typography.Link
                onClick={() => handleEdit(record)}
                disabled={selectedRowKeys.length > 0}
              >
                Edit
              </Typography.Link>
              {mainData && (
                <Typography.Link
                  type="text"
                  disabled={selectedRowKeys.length > 0}
                >
                  <Popconfirm
                    title="Ok to Archive?"
                    onConfirm={() => onArchive(record)}
                    icon={
                      <WarningOutlined
                        style={{
                          color: "red",
                        }}
                      />
                    }
                  >
                    Archive
                  </Popconfirm>
                </Typography.Link>
              )}
            </div>

            {radioData && (
              <div className="tw-mt-2">
                {" "}
                {/* Added margin to move to a new line */}
                <Typography.Link type="danger">
                  <Popconfirm
                    title="Ok to Delete?"
                    onConfirm={() => handleListDelete(record)}
                    icon={<WarningOutlined style={{ color: "red" }} />}
                  >
                    Delete From List
                  </Popconfirm>
                </Typography.Link>
              </div>
            )}
          </div>
        ),
    },
  ];

  const archivedColumns = [
    {
      title: "Patient Name / Age / Gender",
      dataIndex: "patientNameWithDOB",
      key: "patientNameWithDOB",
      width: 300,
      render: (text, record) => (
        <>
          <div className="tw-font-medium">
            {formatOptionLabel({ label: record?.patientNameWithDOB })}
          </div>
          {record.gender === "Male" ? (
            <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
              {record.age} / M
            </p>
          ) : (
            <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
              {record.age} / F
            </p>
          )}
        </>
      ),
    },
    {
      title: "Facility",
      dataIndex: "facilityName",
      key: "facilityName",
      width: 250,
    },
    {
      title: "CCMD Provider",
      dataIndex: "ccmdProvider",
      key: "ccmdProvider",
      width: 150,
    },
    {
      title: "Operation",
      dataIndex: "guid",
      width: 120,
      fixed: "right",
      render: (_, record) => (
        <div className="tw-space-x-6">
          <Typography.Link onClick={() => onUnArchive(record)}>
            Reactivate
          </Typography.Link>
        </div>
      ),
    },
  ];

  const mergedColumns = columns?.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        key: col.key,
      }),
    };
  });

  return (
    <>
      <div className="tw-flex tw-space-x-4 tw-justify-between tw-items-center tw-mb-2">
        <div>
          <Button
            type="primary"
            onClick={() => setSaveListModalOpen(true)}
            disabled={selectedRowKeys.length === 0}
          >
            Add {selectedRowKeys?.length ? selectedRowKeys?.length : ""}{" "}
            Patients To List
          </Button>
          {mainData && (
            <Button type="text" onClick={handleReset} className="tw-ml-2">
              Reset
            </Button>
          )}
        </div>
        <div className="tw-space-x-2 tw-flex tw-items-center">
          {mainData && (
            <Button
              type="default"
              size="middle"
              onClick={openArchiveTable}
              disabled={selectedRowKeys.length > 0 || !tableData || freezeEdit}
              style={{ color: "#EF4444" }}
            >
              Archived Patients
            </Button>
          )}

          <DetailedCSV detailData={tableData || []} event={"HN Prov"} />
        </div>
      </div>
      <Form form={form} component={false}>
        <Table
          rowSelection={radioData ? null : rowSelection}
          columns={mergedColumns}
          dataSource={tableData?.map((item, index) => ({
            ...item,
            key: item?.mbi,
          }))}
          size="middle"
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          scroll={{ x: 2000, y: "60vh" }}
        />
      </Form>
      {saveListModalOpen && (
        <Modal
          open={saveListModalOpen}
          width={500}
          title={"Add patients to list"}
          onCancel={() => setSaveListModalOpen(false)}
          footer={
            <div className="tw-flex tw-justify-end tw-mt-6 tw-space-x-3">
              <Button
                type="default"
                onClick={() => setSaveListModalOpen(false)}
              >
                Cancel
              </Button>
              <Button type="primary" onClick={onPatientListSave}>
                Save
              </Button>
            </div>
          }
        >
          <Select
            showSearch
            allowClear
            placeholder="Select existing list"
            optionFilterProp="children"
            onChange={onListChange}
            value={selectedList}
            options={FavouritesList}
            className="tw-w-full"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        </Modal>
      )}

      {isArchivedModalOpen && (
        <Modal
          open={isArchivedModalOpen}
          width={1000}
          title={"Archived Patients"}
          onCancel={() => setIsArchivedModalOpen(false)}
          footer={null}
        >
          <Table
            columns={archivedColumns}
            dataSource={archivedData}
            size="middle"
          />
        </Modal>
      )}
    </>
  );
};

export default HnProGrpRoundsTable;
